import RadioGroup from '../../../Radio/RadioGroup';
import React from 'react';
import { AnswerSelectWithRadioPresentationProps } from '../Container/Container';
import { Body1Reg, Caption2Reg } from '../../../../config/designSystem/typography';
import { COLORS } from '../../../../config/designSystem/Colors';
import { FC } from 'react';
import { SPACING } from '../../../../config/designSystem/Spacing';
import { Text, TouchableOpacity, View } from 'react-native';
import { observer } from 'mobx-react';
import { useBreakpointWidth } from '../../../../hooks/useBreakpointWidth';

const _Presentation: FC<AnswerSelectWithRadioPresentationProps> = ({
  valueSonar,
  importance,
  labels,
  onSmileyPress,
  onImportanceChange,
}) => {
  const WIDTH_CONTENT = useBreakpointWidth({ sm: 350, md: 800 });

  const smileys = ['🙁', '😐', '😊'];
  const textForSmileys = [
    labels?.SONAR_SMILEY_ANNOTATION?.NOT_OK,
    labels?.SONAR_SMILEY_ANNOTATION?.AVERAGE,
    labels?.SONAR_SMILEY_ANNOTATION?.OK
  ];

  return (
    <View
      style={{
        width: WIDTH_CONTENT,
        alignSelf: 'center',
        marginTop: SPACING['sp-20']
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {smileys.map((smiley, index) => {
          const selectedIndex = index + 1;
          const isSelected = valueSonar === selectedIndex;

          return (
            <React.Fragment key={index}>
              <View style={{ alignItems: 'center' }}>
                <TouchableOpacity
                  onPress={() => onSmileyPress(index)}
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: 25,
                    backgroundColor: isSelected ? COLORS.brand[500] : 'transparent',
                    justifyContent: 'center',
                    alignItems: 'center',
                    shadowColor: isSelected ? '#000' : 'transparent',
                    shadowOffset: {
                      width: 0,
                      height: 2,
                    },
                    shadowOpacity: 0.25,
                    shadowRadius: 3.84,
                    elevation: isSelected ? 5 : 0,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 30,
                      color: isSelected ? '#FFFFFF' : '#000000'
                    }}
                  >
                    {smiley}
                  </Text>
                </TouchableOpacity>
                <View style={{ marginTop: SPACING['sp-4'] }}>
                  <Caption2Reg>
                    {textForSmileys[index]}
                  </Caption2Reg>
                </View>
              </View>

              {index < smileys.length - 1 && (
                <View
                  style={{
                    height: 2,
                    flex: 1,
                    backgroundColor: 'black',
                    marginHorizontal: 5,
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </View>
      <View style={{ rowGap: SPACING['sp-20'], marginTop: SPACING['sp-40'], alignItems: 'center' }}>
        <Body1Reg selectable={true}>
          {labels?.WITH_RADIO}
        </Body1Reg>
        <RadioGroup
          getValue={(key) => importance}
          setValue={(key, value) => onImportanceChange(value)}
          labels={labels?.IMPORTANCE || {}}
          nextAvailable={true}
          onNextCb={() => {}}
        />
      </View>
    </View>
  );
};

export const Presentation = observer(_Presentation);
